import { formatCampaignClockTime } from "@/lib/calendarUtils";

const DAY_MS = 86_400_000;
// Days arrive as campaign-local `yyyy-MM-dd`; formatting them in UTC keeps the browser's zone out of it.
const shortDate = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  timeZone: "UTC",
});

const weekdayDate = new Intl.DateTimeFormat("en-US", {
  weekday: "short",
  month: "short",
  day: "numeric",
  timeZone: "UTC",
});

/** A campaign-local `yyyy-MM-dd` as "Thu, Oct 1". */
export const weekdayDay = (on: string) =>
  weekdayDate.format(new Date(`${on}T00:00:00Z`));

/** A campaign-local `yyyy-MM-dd` as "Sep 29". */
export const shortDay = (on: string) =>
  shortDate.format(new Date(`${on}T00:00:00Z`));

/** Whole days from one campaign-local `yyyy-MM-dd` to another: positive when `to` is later. */
export const daysBetween = (from: string, to: string) =>
  Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / DAY_MS);

/** "today", "yesterday", "3d ago", then a date — both days campaign-local, never browser time. */
export function daysAgo(on: string, today: string) {
  const days = daysBetween(on, today);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 7) return `${days}d ago`;
  return shortDay(on);
}

/** "Today, 10:18 AM" on the campaign's today (the clock in the campaign's zone), else "Sep 22". */
export function dayOrClock(on: string, at: string, today: string) {
  return on === today ? `Today, ${formatCampaignClockTime(at)}` : shortDay(on);
}
